module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_1_3.6370b4cf.png";